const currentYear = new Date().getFullYear();
const previousYear = currentYear - 1;

export const academicYear = `${previousYear}/${currentYear}`;
